import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  {
    num: '01',
    title: 'Audit & Strategy',
    description: 'We analyze your current Instagram, your competitors, and your local market. Then we build a custom growth plan tailored to your business.',
  },
  {
    num: '02',
    title: 'Content Planning',
    description: 'We create a content calendar with Reels scripts, post ideas, and a posting schedule designed to attract your ideal customers.',
  },
  {
    num: '03',
    title: 'Execution',
    description: 'Our team handles content creation guidance, influencer outreach, and profile optimization. You focus on running your business.',
  },
  {
    num: '04',
    title: 'Growth & Optimization',
    description: 'We track what works, double down on winners, and continuously refine your strategy for maximum customer acquisition.',
  },
];

export const ProcessSection = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 md:py-32 bg-slate-50"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="mb-20"
        >
          <span className="font-accent text-slate-400 mb-4 block" data-testid="process-label">
            How It Works
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-slate-900 leading-tight max-w-2xl"
            data-testid="process-headline"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            A Simple, Proven{' '}
            <span className="font-medium">4-Step System</span>
          </h2>
        </motion.div>

        <div className="space-y-0">
          {steps.map((step, i) => (
            <motion.div
              key={step.num}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 py-12 border-b border-slate-200 last:border-b-0"
              data-testid={`process-step-${i}`}
            >
              <div className="md:col-span-2">
                <span
                  className="text-7xl md:text-8xl font-light text-slate-200"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  {step.num}
                </span>
              </div>
              <div className="md:col-span-4 flex items-center">
                <h3
                  className="text-xl md:text-2xl font-medium text-slate-900"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  {step.title}
                </h3>
              </div>
              <div className="md:col-span-6 flex items-center">
                <p className="text-sm md:text-base text-slate-500 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
